import {h} from 'preact';
import {ReviewsApiContainer} from '@containers/CustomerReviews/api';
import {Formik, ErrorMessage} from 'formik';
import invoke from 'lodash.invoke';
import {trimFormData} from '@util/StringUtils'
import {Checkbox} from '@components/common/Form/Checkbox';
import {Textarea} from '@components/common/Form/Textarea';
import Button from '@components/common/Button';
import Message from '@components/common/Message';

const DialogDenyReview = ( props, context ) => {

    const closeModal = () => invoke( context, 'onClose' );

    return (
        <ReviewsApiContainer render={( {updateReviewStatus: {mutation, result}} ) =>
            <Formik
                validate={formData => {
                    const errors = {};
                    const {deniedReasons, otherReason} = trimFormData( formData );

                    if ( deniedReasons.length === 0 ) {
                        errors.deniedReasons = 'Select at least one reason why'
                    }

                    if ( deniedReasons.includes( 'other' ) ) {
                        if ( !otherReason ) {
                            errors.otherReason = 'A message for denial reason is required'
                        }
                        else if ( otherReason.length < 4 ) {
                            errors.otherReason = 'This message is too short'
                        }

                        if ( otherReason.length > 255 ) {
                            errors.otherReason =
                                `This message can only be 255 characters or less (currently ${otherReason.length})`
                        }
                    }

                    return errors;
                }}
                initialValues={{
                    deniedReasons: [],
                    otherReason: ''
                }}
                onSubmit={( {deniedReasons, otherReason} ) => {
                    const formData = {
                        // filter "other" from denialReasons so only id's are passed to conform to api
                        deniedReasons: deniedReasons.filter( v => v !== 'other' ),
                        otherReason,
                        status: 'DENIED'
                    };

                    mutation( {
                        variables: {
                            input: {
                                ...props.submitData,
                                ...trimFormData( formData )
                            }
                        }
                    } ).then( closeModal )
                }}
                render={( {values, errors, touched, setFieldValue, handleSubmit, handleChange} ) => (
                    <div>
                        <p className="mb-2 text-sm">*At least one reason is required</p>
                        <div>
                            <span className="error block mb-2">
                                <ErrorMessage name="deniedReasons"/>
                            </span>
                            <Checkbox label="Inappropriate Language" name="deniedReasons" value="1"/>
                            <Checkbox label="Comment not relevant to product" name="deniedReasons" value="2"/>
                            <Checkbox label="Other" name="deniedReasons" value="other"
                                      onChange={( isChecked ) => {
                                          if ( !isChecked ) {
                                              setFieldValue( 'otherReason', '' );
                                          }
                                      }}/>
                            {values.deniedReasons.includes( 'other' ) ?
                                <div className="max-w-sm">
                                <Textarea
                                    id="otherReason"
                                    label="Reason for denial"
                                    hint="Provide a short message to the customer describing why this review can not be accepted and what they can do to fix it."
                                    onChange={handleChange}
                                    isFocused={true}
                                    error={touched.otherReason && errors.otherReason}
                                    value={values.otherReason}
                                    inputClassName="w-full h-32"
                                    className="mt-2"/>

                                </div> : null}

                            <div className="button-bar mt-8">
                                <Button secondary
                                        onClick={closeModal}>Cancel</Button>
                                <Button primary loading={result.loading}
                                        onClick={handleSubmit}>Submit</Button>

                            </div>
                        </div>
                        {result.error &&
                        <Message fail>There was an error submitting this request, please try
                            again.</Message>
                        }
                    </div>
                )}
            />
        }/>
    );
};

export default DialogDenyReview;